import React from 'react';
import { useHistory } from 'react-router-dom';

import RocketImage from '../../Assets/images/rocket.svg';
import { Button } from '../../Atoms';
import './complete-survey.scss';
const CompleteSurvey = ({
  headingText = 'Congratulations!',
  infoText = 'Thanks for completing the survey',
  hide,
}) => {
  const history = useHistory();

  const handleFeedback = () => {
    history.push('/feedback');
  };

  return (
    <div className="complete-survey-wrapper">
      <div className="header">
        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
        <img src={RocketImage} alt="rocket-image" />
        <h3>{headingText}</h3>
        <p>{infoText}</p>
        {!hide && (
          <div className="header-content">
            <h6>
              Your report and custom action steps are now available for you to
              review.
            </h6>
          </div>
        )}
      </div>
      <div className="footer">
        <h5>
          Peak Mind is always striving to be the best mental well-being platform
          on the market. Please send us a message letting us know how we can
          help you better.
        </h5>
        <Button color="blue" size="lg" onClick={handleFeedback}>
          Send us your feedback
        </Button>
      </div>
    </div>
  );
};

export default CompleteSurvey;
